import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import { loginAction } from './actions/SecurityQuestionsActions';
import React, { Component } from 'react';
import { renderTextField } from '../../components/reduxFields';
import { connect } from 'react-redux';
import Loader from '../../img/loader.gif';
import validate from './validate';
import GlobalVariables from '../../actions/utilAction';
import LogoImageViewer from '../../components/logoImageViewer'; 

class SecurityQuestions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
    this.renderSecurityQuestion = this.renderSecurityQuestion.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // console.log('nextProps', nextProps);
    if (nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage) {
      let errorMessage = nextProps.errorMessage;
      this.setState({ errorMessage: errorMessage });
    }
  }

  onSubmit = (authData) => {
    let SecurityQuestionList = [];
    if (this.props.security_questions && this.props.security_questions.length) {
      this.props.security_questions.map((obj, index) => {
        SecurityQuestionList.push({ Id: 0, QuestionID: obj.id, Answer: authData[`Question${index + 1}`] });
        return SecurityQuestionList;
      });
    }
    // console.log('this.props.authData ', this.props.authData);
    if (this.props.authData && this.props.authData.userName && this.props.authData.password) {
      authData.userName = this.props.authData.userName;
      authData.password = this.props.authData.password;
      authData.SecurityQuestionList = SecurityQuestionList;
      let finalAuthData = {};
      finalAuthData.userName = authData.userName;
      finalAuthData.password = authData.password;
      finalAuthData.SecurityQuestionList = authData.SecurityQuestionList;
      finalAuthData.ipaddress = GlobalVariables.IpAddress;
      finalAuthData.macaddress = 'ec:aa:a0:2d:dc:67';
      // console.log('final authdata', JSON.stringify(finalAuthData));
      this.props.loginAction(finalAuthData, this.props.businessNameCheck);
    }

  }
  renderSecurityQuestion() {
    this.props.security_questions.map((ques, index) => {
      return (
        <div key = {index} className ="require">
          <Field
            name={`Question${ index + 1 }`}
            type="text"
            maxLength="30"
            label={ques.question}
            component={renderTextField} />
        </div>);
    });
  };


  // return (
  //   <div>
  //     {console.log('inside the field array')}
  //     { fields.map((ques, index) =>

  //       <div key = {index} className ="require">
  //         {console.log(ques)}
  //         <Field
  //           name={`Question${ index + 1 }`}
  //           type="text"
  //           maxLength="30"
  //           label={ques.question}
  //           component={renderTextField}
  //         />
  //       </div>)
  //     }
  //   </div>
  // );
  // };


  render() {
    const { handleSubmit, authenticatingToken } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <div className="login-fields">
            <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="loginlogo">
                <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
              </div>
              {this.state.errorMessage !== null ?
                <div className="alert-danger">{this.state.errorMessage}</div>
                : ''}
              {this.props.security_questions && this.props.security_questions.length ?
                <div>
                  {this.props.security_questions.map((ques, index) => {
                    return (
                      <div key = {index} className ="require">
                        <Field
                          name={`Question${ index + 1 }`}
                          type="text"
                          maxLength="30"
                          label={ques.question}
                          component={renderTextField} />
                      </div>);
                  })}
                  <div className="pt20">
                    {this.props.authenticating ? <LoginButtonDisabled label="Saving" /> : <LoginButton label="Save security questions" />}
                  </div>
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  // console.log('ownProps-->', ownProps);
  return {
    authenticating: state.login.authenticating,
    authenticatingToken: state.login.authenticatingToken,
    errorMessage: state.login.errorMessage,
    security_questions: ownProps && ownProps.location && ownProps.location.state && ownProps.location.state.response && ownProps.location.state.response.data ? ownProps.location.state.response.data : [],
    authData: ownProps && ownProps.location && ownProps.location.state && ownProps.location.state.authData ? ownProps.location.state.authData : {},
    loaderBusinessToken: state.login.loaderBusinessToken,
    businessNameCheck: state.login.businessNameCheck,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    businessCheckMessage: state.login.businessCheckMessage,
    organizationDetails: state.login.organizationDetails,
  };
}

SecurityQuestions = reduxForm({
  form: 'SecurityQuestionsForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(SecurityQuestions);

export default connect(mapStateToProps, { loginAction })(SecurityQuestions);



// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/index.js